import React from 'react';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { SBOM_CONSTANTS } from '../../../components/SBOM/SBOM.constants';

/**
 * Component to render SBOM components in a table format
 * @param {Array} components - Array of component objects with name, type, vendor, version
 */
export default function ComponentTable({ components }) {
  const theme = useTheme();

  if (!components || !Array.isArray(components) || components.length === 0) {
    return null;
  }

  // Map component type from COMPONENT_TYPE_* format to display format
  const getTypeDisplay = type => {
    if (!type) return '';
    // Remove COMPONENT_TYPE_ prefix if present
    const typeWithoutPrefix = type.replace(/^COMPONENT_TYPE_/, '');
    // Map to display name using SBOM constants
    return SBOM_CONSTANTS.TYPE_COLUMN_MAP[typeWithoutPrefix] || typeWithoutPrefix;
  };

  return (
    <Box sx={{ mt: 2, mb: 1 }}>
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, color: theme.palette.text.secondary }}>
        Components ({components.length})
      </Typography>
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: 400,
          border: `1px solid ${theme.palette.divider}`,
          overflow: 'auto',
          '&::-webkit-scrollbar': {
            display: 'none'
          },
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }}
      >
        <Table size="medium" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600, backgroundColor: theme.palette.background.default }}>
                Name
              </TableCell>
              <TableCell sx={{ fontWeight: 600, backgroundColor: theme.palette.background.default }}>Type</TableCell>
              <TableCell sx={{ fontWeight: 600, backgroundColor: theme.palette.background.default }}>Vendor</TableCell>
              <TableCell sx={{ fontWeight: 600, backgroundColor: theme.palette.background.default }}>Version</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {components.map((component, index) => (
              <TableRow key={index} hover>
                <TableCell>{component.name || '-'}</TableCell>
                <TableCell>{getTypeDisplay(component.type)}</TableCell>
                <TableCell>{component.vendor || '-'}</TableCell>
                <TableCell>{component.version || '-'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
